import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { OrganizationDOAMaster } from '../../model/OrganizationDOAMaster.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-doa-master',
  templateUrl: './doa-master.component.html',
  styleUrls: ['./doa-master.component.css']
})
export class DoaMasterComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;

  //Master Model
  ListStatus: LookupInfo[] = [];
  ListWorkflowType: LookupInfo[] = [];
  ListMasterManagement: OrganizationDOAMaster[] = [];
  organizationDoaMasterInfo: OrganizationDOAMaster = new OrganizationDOAMaster;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchMasterName: string;
  txtSchMasterCode: string;
  ddlSchMasterStatus: string = "";

  //Form variable
  masterForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalMaster: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchMasterStatus = 'Y'

    //Load init data
    this.LoadLookupType("MASTERSTATUS").then((data) => {
        this.ListStatus = data;
      });
    this.LoadLookupType("WORKFLOWTYPE").then((data) => {
        this.ListWorkflowType = data;
      });

    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
    this.LoadCountMasterList();

    //Declare form
    this.masterForm = new FormGroup({
      WorkflowType: new FormControl(this.organizationDoaMasterInfo.WorkflowType, [Validators.required]),
      MasterCode: new FormControl(this.organizationDoaMasterInfo.GroupCodeDOA, [Validators.required]),
      MasterName: new FormControl(this.organizationDoaMasterInfo.DOAName, [Validators.required]),
      MasterStatus: new FormControl(this.organizationDoaMasterInfo.FlagActive)
    });
  }

  get WorkflowType() { return this.masterForm.get('WorkflowType'); }
  get MasterCode() { return this.masterForm.get('MasterCode'); }
  get MasterName() { return this.masterForm.get('MasterName'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadMasterList(dataId: number = 0): Promise<OrganizationDOAMaster[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['WorkflowType'] = $('#ddlSchWorkflowType').val();
      objectjson['GroupCodeDOA'] = this.txtSchMasterCode; 
      objectjson['DOAName'] = this.txtSchMasterName;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<OrganizationDOAMaster[]>(this.baseurl + "DOAMapping/GetMasterDOA", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['WorkflowType'] = $('#ddlSchWorkflowType').val();
      objectjson['GroupCodeDOA'] = this.txtSchMasterCode;
      objectjson['DOAName'] = this.txtSchMasterName;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "DOAMapping/GetCountMasterDOA", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchMasterCode = null;
    this.txtSchMasterName = null;
    $('#ddlSchMasterStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });
  }

  //Create btn
  OnCreateMaster_Click() {

    $('#modalCreateMasterTitle').html('Create Master DOA');
    $('#modalCreateOrEditMaster').modal();
    this.organizationDoaMasterInfo = new OrganizationDOAMaster;
    this.MasterCode.setValue(null);
    this.MasterName.setValue(null);
    this.WorkflowType.setValue(null);

    this.masterForm.markAsUntouched();
    this.masterForm.markAsPristine();
  }
  OnDdlWorkflowType_Change()
  {
    $('#MasterCode').prop('disabled', false);
    $('#MasterName').prop('disabled', false);
  }

  async OnSubmitCreateMaster_Click() {
    if (this.masterForm.valid && !this.IsDuplicateCode) {
     
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.masterForm.value;

        objectjson['WorkflowType'] = this.masterForm.get('WorkflowType').value;
        objectjson['GroupCodeDOA'] = this.masterForm.get('MasterCode').value;
        objectjson['DOAName'] = this.masterForm.get('MasterName').value;
        objectjson['FlagActive'] = this.masterForm.get('MasterStatus').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/InsertMasterDOA", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'Position level has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditMaster').modal('hide');
           
            //Reload
            this.LoadMasterList().then((data) => {
              this.ListMasterManagement = data;
            });
            this.LoadCountMasterList();
          });
      }
    } else {
      this.markFormGroupTouched(this.masterForm);
    }

  }
  async OnEdit_Click(masterId) {

    if (!!masterId) {
      this.OnDdlWorkflowType_Change();
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadMasterList(masterId).then((data) => {

          this.organizationDoaMasterInfo = data[0];
          this.MasterCode.setValue(data[0].GroupCodeDOA);
          this.MasterName.setValue(data[0].DOAName);
          this.WorkflowType.setValue(data[0].WorkflowType);

          setTimeout(() => {
     
            $('#modalCreateMasterTitle').html('Edit Master DOA');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.masterForm.valid && !this.IsDuplicateCode) {
      
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.masterForm.value;
        objectjson['GroupCodeDOA'] = this.masterForm.get('MasterCode').value;
        objectjson['DOAName'] = this.masterForm.get('MasterName').value;
        objectjson['FlagActive'] = this.masterForm.get('MasterStatus').value;

        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.organizationDoaMasterInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/UpdatePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'Position level has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditMaster').modal('hide');
             
              //Reload
              this.LoadMasterList().then((data) => {
                this.ListMasterManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditMaster').modal('hide');
              
            }
          });
      }
    } else {
      this.markFormGroupTouched(this.masterForm);
    }
  }
  async OnDelete_Click(masterId) {
    if (!!masterId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.masterForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = masterId;

        let arrjson: OrganizationDOAMaster[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/DeletePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.isSearchSubmitted = false;
              this.titlemodal = '';
              this.detailmodal = 'Position level has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Reload
              this.LoadMasterList().then((data) => {
                this.ListMasterManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

            }
          });
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: OrganizationDOAMaster[] = [];

    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new OrganizationDOAMaster;
      model.Id = curId;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these DOA?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "DOAMapping/DeletePositionLevelManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'Position levels have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadMasterList().then((data) => {
                    this.ListMasterManagement = data;
                  });
                  this.LoadCountMasterList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at lease 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }
  async OnMapping_Click(wfType, groupCode) {
    this.router.navigate(['/master-doa-mapping', { wf: wfType, groupcode: groupCode }])
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {
    
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadMasterList(positionId).then((data) => {

          this.organizationDoaMasterInfo = data[0];
          this.MasterCode.setValue(data[0].GroupCodeDOA);
          this.MasterName.setValue(data[0].DOAName);
          this.WorkflowType.setValue(data[0].WorkflowType);

          setTimeout(() => {
           
            $('#modalCreateMasterTitle').html('Edit position level');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['WorkflowType'] = this.WorkflowType.value;
      objectjson['GroupCodeDOA'] = this.MasterCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "DOAMapping/CheckDuplicateGroupApproverCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadMasterList().then((data) => {
      this.ListMasterManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalMaster = data;
    if (this.totalMaster == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalMaster / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
